import { config } from 'env_def';
import { fromEventPattern, from, Observable, interval, of } from 'rxjs';
import { map, switchMap, tap, shareReplay, withLatestFrom, distinctUntilChanged, mergeMap, take, defaultIfEmpty, timeout, catchError, combineLatestWith, filter, debounceTime, bufferWhen, mapTo, delay, } from 'rxjs/operators';
import lodashGet from 'lodash/get';
import { apis, inWindow } from '@/config';
import { api } from '@/api/api';
const replaceMsgTime2Updatetime = session => {
    const msgtime = lodashGet(session, 'lastMsg.time', 0);
    const draftTime = lodashGet(session, 'localCustom.time', 0);
    if (msgtime !== 0 && msgtime > draftTime) {
        session.updateTime = msgtime;
    }
    return session;
};
const replaceUpdatetimeBydraft = session => {
    const draftTime = lodashGet(session, 'localCustom.time', 0);
    if (Math.max(draftTime, session.updateTime) === draftTime) {
        session.updateTime = draftTime;
    }
    return session;
};
const switchLocalCustom = session => {
    if (typeof session.localCustom !== 'string') {
        return session;
    }
    try {
        session.localCustom = JSON.parse(session.localCustom);
    }
    catch (ex) {
        session.localCustom = {};
    }
    return session;
};
const filterInvalidLocalMsg = (session) => {
    if (lodashGet(session, 'lastMsg.text', '') === 'CREATE_CONVERSATION_MSG') {
        session.lastMsg = undefined;
    }
    return session;
};
const isInValidSession = (session, myAccount) => {
    const attachType = lodashGet(session, 'lastMsg.attach.type', 'none');
    if (attachType === 'dismissTeam') {
        return false;
    }
    if (attachType === 'leaveTeam') {
        const users = lodashGet(session, 'lastMsg.attach.users', []);
        return !users.map(item => item.account).includes(myAccount);
    }
    if (attachType === 'removeTeamMembers') {
        const accounts = lodashGet(session, 'lastMsg.attach.accounts', []);
        return !accounts.includes(myAccount);
    }
    return true;
};
export class SessionStream {
    constructor() {
        this.sdk = null;
        this.subject = null;
        this.sessionList = { list: [] };
        this.eventApi = api.getEventApi();
        this.systemApi = api.getSystemApi();
        this.httpApi = api.getDataTransApi();
        this.accountApi = api.requireLogicalApi(apis.accountApiImpl);
    }
    init(sdk) {
        this.sdk = sdk;
        const $source = new Observable(o => {
            this.sessionList = new Proxy(this.sessionList, {
                set(target, key, value) {
                    if (key === 'list') {
                        o.next(value);
                    }
                    return Reflect.set(target, key, value);
                },
            });
        });
        const $t = $source.pipe(shareReplay(1));
        this.subject = $t;
        const $myInfo = sdk.imself.getSubject();
        $t.pipe(debounceTime(100), map(sessions => sessions.filter(session => lodashGet(session, 'lastMsg.attach.type.length', 0) !== 0)), combineLatestWith($myInfo), map(([sessions, myinfo]) => {
            const toDeletedIds = sessions.filter(session => !isInValidSession(session, myinfo.account)).map(session => session.id);
            return toDeletedIds;
        }), filter(toDeletedIds => toDeletedIds.length > 0)).subscribe(toDeletedIds => {
            this.sessionList.list = this.sessionList.list.filter(item => !toDeletedIds.includes(item.id));
            toDeletedIds.forEach(id => {
                this.sdk.excute('deleteLocalSession', {
                    id,
                });
            });
        });
        this._onsessions();
        this._onupdatesessions();
        this._onnetworkchanged();
    }
    _onsessions() {
        const onsession = (handler) => {
            this.sdk.subscrible('onsessions', handler);
        };
        const onremovesession = (handler) => {
            this.sdk.unSubcrible('onsessions', handler);
        };
        const activeUpdateSession = () => interval(10000).pipe(take(5), switchMap(() => {
            const $request = this._fetchSessionList({ limit: 100 });
            return from($request).pipe(timeout(8000), map(result => (Array.isArray(result) ? result : [])), catchError(() => of().pipe(defaultIfEmpty([]))));
        }), tap(sessions => {
            console.log('[im.sessions]getlocalsessions', sessions);
        }));
        const $event = fromEventPattern(onsession, onremovesession).pipe(take(1), tap(list => {
            console.log('[im.sessions]init', list);
        }), timeout({
            first: 60 * 1000,
        }), catchError(error => {
            console.log('[im.sessions]onsessionfailed', error);
            this.eventApi.sendSysEvent({
                eventName: 'initModule',
                eventStrData: 'im',
            });
            return activeUpdateSession();
        }), map(sessions => sessions.map(session => [
            switchLocalCustom,
            replaceMsgTime2Updatetime,
            replaceUpdatetimeBydraft,
            filterInvalidLocalMsg,
        ].reduce((total, current) => current(total), session))));
        const fetchyunxinId = async () => {
            const user = this.systemApi.getCurrentUser();
            const yxIndex = lodashGet(user, 'contact!.contactInfo', []).findIndex(({ contactItemType }) => contactItemType === 'yunxin');
            if (yxIndex !== -1) {
                return lodashGet(user, `contact.contactInfo[${yxIndex}].contactItemVal`, '');
            }
            const result = (await this.accountApi.fetchAccountInfo());
            return lodashGet(result, 'data.data.yunxinAccountId', '');
        };
        const url = this.systemApi.getUrl('getHasSession');
        const appkey = config('NIMSID');
        const MAX_DAYS = appkey.startsWith('13af9') ? 7 : 30;
        from(fetchyunxinId())
            .pipe(switchMap(yxId => {
            if (!yxId) {
                return of(false);
            }
            const $request = this.httpApi.get(url, {
                yxId,
                minTimestamp: new Date().getTime() - MAX_DAYS * 24 * 60 * 60 * 1000,
            });
            return from($request).pipe(map(res => lodashGet(res, 'data.data', true) === false));
        }), catchError(error => {
            console.error(`[im.sessionlist]server:${url}.error:`, error);
            return of(false);
        }), filter(flag => flag), mapTo([]))
            .subscribe(() => {
            this.sessionList.list = [];
        });
        $event.subscribe({
            next: async (list) => {
                this.sessionList.list = await this.sdk.excuteSync('mergeSessions', this.sessionList.list, list);
            },
            error(error) {
                console.error('[im.sessionlist]onsession.caughterror', error);
            },
        });
    }
    _onupdatesessions() {
        const onupdatesession = (handler) => {
            this.sdk.subscrible('onupdatesession', handler);
        };
        const onremoveupdatesession = (handler) => {
            this.sdk.unSubcrible('onupdatesession', handler);
        };
        const $event = fromEventPattern(onupdatesession, onremoveupdatesession);
        return $event
            .pipe(tap(session => {
            console.log('[im.session]onupdatesession', session);
        }), filter(item => lodashGet(item, 'updateTime', 0) !== 0))
            .pipe(map(session => [
            switchLocalCustom,
            replaceMsgTime2Updatetime,
            replaceUpdatetimeBydraft,
            filterInvalidLocalMsg,
        ].reduce((total, current) => current(total), session)))
            .subscribe(async (session) => {
            const sessions = (await this.sdk.excuteSync('mergeSessions', this.sessionList.list, session));
            this.sessionList.list = sessions;
        });
    }
    _onnetworkchanged() {
        if (!inWindow()) {
            return;
        }
        const onconnect = (handler) => {
            this.sdk.subscrible('onconnect', handler);
        };
        const offconnect = (handler) => {
            this.sdk.unSubcrible('onconnect', handler);
        };
        const $connect = fromEventPattern(onconnect, offconnect);
        const onwillconnect = (handler) => {
            this.sdk.subscrible('onwillreconnect', handler);
        };
        const offwillconnect = (handler) => {
            this.sdk.unSubcrible('onwillreconnect', handler);
        };
        const $reconnect = fromEventPattern(onwillconnect, offwillconnect);
        $reconnect
            .pipe(mapTo(1), bufferWhen(() => $connect), filter(list => list.includes(1)), switchMap(() => interval(3000).pipe(take(3), mergeMap(() => this._fetchSessionList()))), map(sessions => sessions.map(session => replaceUpdatetimeBydraft(switchLocalCustom(session)))))
            .subscribe(async (list) => {
            const mergedlist = (await this.sdk.excuteSync('mergeSessions', this.sessionList.list, list));
            this.sessionList.list = mergedlist;
        });
    }
    async _fetchSessionList(options = {}) {
        if (!this.sdk || !this.sdk.getInstance()) {
            return [];
        }
        try {
            const res = (await this.sdk.excute('getLocalSessions', Object.assign({ limit: 50 }, options)));
            return res.sessions;
        }
        catch (e) {
            console.warn('[im]', e);
            return [];
        }
    }
    async getMoreSessions(options = {}) {
        var _a;
        const sessions = (await this._fetchSessionList(options));
        const list = (await ((_a = this.sdk) === null || _a === void 0 ? void 0 : _a.excuteSync('mergeSessions', this.sessionList.list, sessions)));
        this.sessionList.list = list;
        return Promise.resolve();
    }
    async deleteSession(id) {
        await this.sdk.excute('deleteLocalSession', {
            id,
            isLogic: true,
        });
        this.sessionList.list = this.sessionList.list.filter(item => {
            if (Array.isArray(id)) {
                return !id.includes(item.id);
            }
            return id !== item.id;
        });
    }
    getSubject() {
        return this.subject;
    }
    getSession($ids) {
        const $sessionId = $ids.pipe(map(args => (Array.isArray(args) ? args[0] : args)));
        return this.subject.pipe(withLatestFrom($sessionId), map(args => {
            const [sessionList, ids] = args;
            const targetSession = sessionList.find(session => {
                if (Array.isArray(ids)) {
                    return session.id === ids[0];
                }
                return session.id === ids;
            });
            return targetSession;
        }));
    }
    getSessionField($args, $hash) {
        const $sessionId = $args.pipe(map(args => args[0]));
        const $key = $args.pipe(map(args => args[1]));
        const $val = this.subject.pipe(withLatestFrom($sessionId), map(args => {
            const [sessionList, sessionId] = args;
            const targetSession = sessionList.find(session => session.id === sessionId);
            return targetSession;
        }), withLatestFrom($key), map(args => {
            const [session, key] = args;
            return lodashGet(session, key);
        }), distinctUntilChanged());
        if ($hash) {
            const $hashChanged = $hash.pipe(delay(20), map(val => val.includes('message')), distinctUntilChanged());
            return $val.pipe(combineLatestWith($hashChanged), filter(([, flag]) => flag), map(([data]) => data));
        }
        return $val;
    }
    updateLocalCustom(sessionId, info) {
        const $args = of().pipe(defaultIfEmpty([sessionId, 'localCustom']));
        this.getSessionField($args)
            .pipe(take(1))
            .subscribe(localCustom => {
            var _a;
            let _customObj = localCustom;
            try {
                _customObj = JSON.parse(localCustom);
            }
            catch (ex) { }
            (_a = this.sdk) === null || _a === void 0 ? void 0 : _a.excute('updateLocalSession', {
                id: sessionId,
                localCustom: JSON.stringify(Object.assign(_customObj || {}, info)),
            });
        });
    }
}
